<template>
<div class="home page home--id">
  <HeadNav selectedLanguage="id" page="gb" :gotodownload="gotodownload" :apk="apk" />

  <HomeHero :content="heroContent" :download-href="downloadHref" @download="triggerDownload" />

  <div class="home-longform">
    <section class="section-content">
      <h2 class="home-longform__h1">Mengapa Memilih WA GB?</h2>
      <p><strong>Lebih bebas, lebih mudah disesuaikan, dan lebih banyak kontrol.</strong></p>
      <p>
        <router-link to="/id/"><strong>WA GB</strong></router-link> dibuat untuk pengguna Android yang ingin pengalaman chat lebih fleksibel daripada aplikasi standar. Aplikasi ini menawarkan kontrol privasi lanjutan, tema yang bisa diubah, berbagi media berukuran lebih besar, dan alat produktivitas untuk percakapan harian.
      </p>
      <h3>Privasi Lebih Baik</h3>
      <p>Sembunyikan status online, bekukan terakhir dilihat, sembunyikan centang biru, dan atur siapa yang bisa melihat aktivitas Anda.</p>
      <h3>Kustomisasi Penuh</h3>
      <p>Personalisasi chat dengan tema, font, wallpaper, ikon, dan gaya warna sesuai selera.</p>
      <h3>Berbagi Media Lebih Lengkap</h3>
      <p>Kirim video lebih besar, gambar HD, dokumen, dan lebih banyak file dengan batasan yang lebih longgar.</p>
      <h3>Pesan Lebih Praktis</h3>
      <p>Gunakan balasan otomatis, penjadwal pesan, mode DND, dan alat lain untuk memudahkan percakapan sehari-hari.</p>
      <h3>Mudah Digunakan</h3>
      <p>Pasang di sebagian besar perangkat Android dan nikmati tampilan yang familiar dengan fitur tambahan.</p>
      <h3>Pembaruan Rutin</h3>
      <p>
        WA GB membantu Anda mengikuti rilis <router-link to="/id/"><strong>WA GB APK</strong></router-link> terbaru, panduan update, dan perubahan versi.
      </p>
    </section>

    <section class="section-content">
      <h2>Apa yang Baru di Update V18.80 Terbaru?</h2>
      <p>Update WA GB terbaru berfokus pada <strong>stabilitas yang lebih baik, kompatibilitas yang lebih luas, dan pengalaman chat yang lebih mulus</strong>. Baik Anda memperbarui dari versi lama maupun memasang untuk pertama kali, rilis ini membawa beberapa peningkatan yang terasa.</p>
      <h3>Performa Lebih Cepat</h3>
      <p>Waktu buka aplikasi lebih singkat dan navigasi terasa lebih lancar.</p>
      <h3>Perbaikan Bug</h3>
      <p>Memperbaiki masalah umum seperti crash, notifikasi terlambat, dan error saat memuat media.</p>
      <h3>Privasi Ditingkatkan</h3>
      <p>Opsi privasi diperbarui agar Anda punya kontrol lebih baik atas status online, tanda baca, dan visibilitas chat.</p>
      <h3>Dukungan Android Lebih Baik</h3>
      <p>Kompatibilitas dengan versi Android terbaru dioptimalkan untuk stabilitas yang lebih baik.</p>
      <h3>Penyempurnaan UI</h3>
      <p>Elemen antarmuka dibuat lebih rapi sehingga pengalaman penggunaan terasa lebih bersih.</p>
      <h3>Optimasi Umum</h3>
      <p>Peningkatan kecil pada performa, keandalan, dan kenyamanan pemakaian harian.</p>
    </section>

    <section class="section-content">
      <h2>Fitur Unggulan WA GB</h2>
      <p>WA GB memberi pengalaman chat yang lebih fleksibel lewat fitur yang tidak tersedia di aplikasi resmi. Mulai dari kontrol privasi lanjutan dan tema personal sampai alat pesan pintar serta berbagi media lebih besar, WhatsApp GB cocok untuk pengguna yang ingin mengatur cara mereka berkomunikasi. Lihat beberapa fitur favorit di bawah ini.</p>
      <figure class="home-doc-figure home-doc-figure--features">
        <img
          src="@/assets/gb-wave-1.webp"
          alt="Fitur privasi WA GB termasuk Ghost Mode dan freeze last seen"
          width="1280"
          height="853"
          loading="lazy">
      </figure>
      <div class="top-features-grid">
        <article v-for="f in topFeatures" :key="f.title" class="top-features-grid__item">
          <h3>{{ f.title }}</h3>
          <p>{{ f.body }}</p>
        </article>
      </div>
    </section>

    <section class="section-content">
      <h2>Informasi Unduhan</h2>
      <p>Periksa detail rilis terbaru sebelum mengunduh WA GB. Berikut spesifikasi utama untuk versi saat ini.</p>
      <table class="data-table data-table--slim">
        <thead>
          <tr>
            <th scope="col">Informasi</th>
            <th scope="col">Detail</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in apkInfoRows" :key="row.label">
            <th scope="row">{{ row.label }}</th>
            <td>{{ row.value }}</td>
          </tr>
        </tbody>
      </table>
    </section>

    <section class="section-content">
      <h2>Cara Mengunduh dan Memasang WA GB</h2>
      <p>
        Memasang <router-link to="/id/">WA GB</router-link> hanya membutuhkan beberapa menit.
        Ikuti <strong>4 langkah</strong> sederhana ini untuk mengunduh, memasang, dan memverifikasi aplikasi di perangkat Android Anda.
      </p>
      <ol class="install-steps">
        <li v-for="step in installSteps" :key="step.title" class="install-steps__item">
          <span class="install-steps__num" aria-hidden="true">{{ step.num }}</span>
          <h3 class="install-steps__title">{{ step.title }}</h3>
          <p class="install-steps__body" v-html="step.body" />
        </li>
      </ol>
      <h3>Sebelum Memasang</h3>
      <figure class="home-doc-figure home-doc-figure--install">
        <img
          src="@/assets/gb-wave-2.webp"
          alt="Prompt instalasi Android untuk memasang WA GB APK"
          width="778"
          height="522"
          loading="lazy">
      </figure>
      <p>&check; Cadangkan chat sebelum update atau berganti perangkat.</p>
      <p>&check; Pastikan perangkat Android menjalankan Android 5.0 atau lebih baru.</p>
      <p>&check; Unduh versi terbaru dari <strong>GB Wave</strong> untuk kompatibilitas dan performa terbaik.</p>
    </section>

    <section class="section-content">
      <h2>Persyaratan Sebelum Mengunduh WA GB</h2>
      <p>Sebelum mengunduh WA GB, pastikan perangkat Android Anda memenuhi persyaratan dasar. Mengecek perangkat lebih dulu membantu proses instalasi berjalan lancar dan performa lebih stabil setelah dipasang.</p>
      <h3>Versi Android</h3>
      <p>WA GB mendukung <strong>Android 5.0 ke atas</strong>. Versi Android yang lebih baru biasanya memberi kompatibilitas dan stabilitas lebih baik.</p>
      <h3>Ruang Penyimpanan</h3>
      <p>Sediakan setidaknya <strong>200 MB ruang kosong</strong> untuk memasang APK serta menyimpan update, file media, dan cadangan chat.</p>
      <h3>RAM yang Disarankan</h3>
      <p>Perangkat dengan <strong>RAM 2 GB</strong> adalah syarat minimum, sementara <strong>4 GB atau lebih</strong> disarankan untuk multitasking yang lebih lancar.</p>
      <h3>Koneksi Internet</h3>
      <p>Koneksi Wi-Fi atau data seluler yang stabil diperlukan untuk verifikasi nomor, mengunduh update, memulihkan cadangan, dan sinkronisasi media.</p>
      <h3>Perangkat yang Kompatibel</h3>
      <p>WA GB berjalan di sebagian besar smartphone Android, termasuk <strong>Samsung, Xiaomi, OPPO, vivo, realme, Motorola, OnePlus, Google Pixel, Huawei,</strong> dan merek lain dengan Android 5.0 atau lebih baru.</p>
      <h3>Sebelum Mulai</h3>
      <p>Sebelum instalasi, pastikan <strong>Instal Aplikasi Tidak Dikenal</strong> sudah diaktifkan, baterai cukup, dan chat sudah dicadangkan jika Anda memperbarui dari versi lama.</p>
    </section>

    <section class="section-content">
      <h2>Kontrol Privasi Lanjutan</h2>
      <p>Lindungi privasi dengan pengaturan yang memberi lebih banyak kontrol atas aktivitas chat. WA GB menyertakan opsi lanjutan agar Anda dapat menentukan apa yang terlihat oleh orang lain.</p>
      <table class="data-table data-table--slim">
        <thead>
          <tr>
            <th scope="col">Fitur</th>
            <th scope="col">Deskripsi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in privacyRows" :key="row.label">
            <th scope="row">{{ row.label }}</th>
            <td>{{ row.value }}</td>
          </tr>
        </tbody>
      </table>
    </section>
    <section class="section-content">
      <h2>Sesuaikan Pengalaman Chat Anda</h2>
      <p>Personalisasi setiap bagian aplikasi chat dengan alat kustomisasi yang lengkap. Ubah tampilan, warna, dan tata letak agar pengalaman chat sesuai gaya Anda.</p>
      <table class="data-table data-table--slim">
        <thead>
          <tr>
            <th scope="col">Fitur</th>
            <th scope="col">Deskripsi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in customizeRows" :key="row.label">
            <th scope="row">{{ row.label }}</th>
            <td>{{ row.value }}</td>
          </tr>
        </tbody>
      </table>
    </section>
    <section class="section-content">
      <h2>Bagikan File Besar Tanpa Batas Ketat</h2>
      <p>Bagikan konten favorit lebih mudah dengan dukungan media yang ditingkatkan. WhatsApp GB memungkinkan pengiriman file lebih besar dan menjaga kualitas gambar maupun video dalam percakapan harian.</p>
      <table class="data-table data-table--slim">
        <thead>
          <tr>
            <th scope="col">Fitur</th>
            <th scope="col">Deskripsi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in mediaRows" :key="row.label">
            <th scope="row">{{ row.label }}</th>
            <td>{{ row.value }}</td>
          </tr>
        </tbody>
      </table>
    </section>
    <section class="section-content">
      <h2>Balasan Otomatis dan Penjadwal Pesan</h2>
      <p>Hemat waktu dengan mengotomatiskan percakapan rutin. Saat sibuk, bepergian, atau mengelola pesan kerja, alat bawaan ini membantu Anda tetap responsif tanpa terus memeriksa ponsel.</p>
    </section>
    <section class="section-content">
      <h2>Pengunduh Status dan Alat Media</h2>
      <p>Kelola status dan file media tanpa aplikasi tambahan. Alat bawaan membuat konten yang ingin Anda simpan lebih mudah diunduh, diatur, dan ditemukan kembali.</p>
      <table class="data-table data-table--slim">
        <thead>
          <tr>
            <th scope="col">Fitur</th>
            <th scope="col">Deskripsi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in statusToolRows" :key="row.label">
            <th scope="row">{{ row.label }}</th>
            <td>{{ row.value }}</td>
          </tr>
        </tbody>
      </table>
    </section>

    <section class="section-content">
      <h2>Cara Memperbarui WA GB</h2>
      <p>Menjaga WA GB tetap terbaru membantu meningkatkan kompatibilitas, stabilitas, dan akses ke fitur baru. Sebelum memasang versi baru, sebaiknya cadangkan chat agar percakapan dapat dipulihkan jika dibutuhkan.</p>
      <ol class="update-steps">
        <li class="update-steps__item">
          <span class="update-steps__num" aria-hidden="true">1</span>
          <div class="update-steps__body">
            <h3 class="update-steps__title">Cadangkan Chat</h3>
            <p>Buat cadangan lokal sebelum update agar pesan penting tetap aman.</p>
          </div>
        </li>
        <li class="update-steps__item">
          <span class="update-steps__num" aria-hidden="true">2</span>
          <div class="update-steps__body">
            <h3 class="update-steps__title">Unduh APK Terbaru</h3>
            <p>Dapatkan versi WA GB terbaru dari <strong>GB Wave</strong> dan simpan APK di perangkat.</p>
          </div>
        </li>
        <li class="update-steps__item">
          <span class="update-steps__num" aria-hidden="true">3</span>
          <div class="update-steps__body">
            <h3 class="update-steps__title">Pasang di Atas Versi Lama</h3>
            <p>Buka APK dan pasang tanpa menghapus aplikasi saat ini, kecuali panduan update meminta instalasi bersih.</p>
          </div>
        </li>
        <li class="update-steps__item">
          <span class="update-steps__num" aria-hidden="true">4</span>
          <div class="update-steps__body">
            <h3 class="update-steps__title">Pulihkan Chat</h3>
            <p>Buka aplikasi, verifikasi nomor telepon, lalu pulihkan cadangan lokal jika diminta saat setup.</p>
          </div>
        </li>
      </ol>
      <h3>Tips Update</h3>
      <p>&check; <strong>Cadangkan chat</strong> sebelum setiap update.</p>
      <p>&check; <strong>Pasang di atas versi yang ada</strong> bila memungkinkan agar data tetap tersimpan.</p>
      <p>&check; <strong>Gunakan rilis stabil terbaru</strong> untuk performa dan kompatibilitas lebih baik.</p>
    </section>

    <section class="section-content">
      <h2>Cadangkan dan Pulihkan Chat Anda</h2>
      <p>Lindungi percakapan sebelum update, instal ulang, atau pindah ke perangkat baru. Membuat cadangan hanya butuh beberapa menit dan memudahkan pemulihan jika terjadi masalah saat instalasi.</p>
      <h3>Buat Cadangan Lokal</h3>
      <p>Simpan chat dan media di perangkat sebelum memperbarui WA GB.</p>
      <h3>Pulihkan Percakapan</h3>
      <p>Pulihkan cadangan setelah memverifikasi nomor telepon saat setup.</p>
      <h3>Pindah ke Ponsel Baru</h3>
      <p>Pindahkan cadangan lokal ke perangkat Android lain dan lanjutkan percakapan Anda.</p>
      <h3>Cegah Kehilangan Data</h3>
      <p>Cadangan rutin membantu melindungi pesan, foto, video, dan dokumen penting.</p>
      <h3>Kapan Perlu Backup?</h3>
      <p>&check; Sebelum memperbarui ke versi lebih baru</p>
      <p>&check; Sebelum menginstal ulang aplikasi</p>
      <p>&check; Sebelum berganti ke ponsel Android baru</p>
      <p>&check; Sebelum menghapus data aplikasi atau mereset perangkat</p>
    </section>

    <section class="section-content">
      <h2>Versi Lama WA GB</h2>
      <p>Versi terbaru disarankan untuk sebagian besar pengguna, tetapi rilis lama bisa berguna jika Anda memakai perangkat Android lama, lebih nyaman dengan tampilan sebelumnya, atau mengalami masalah kompatibilitas setelah update. GB Wave juga menyediakan arsip versi agar Anda mudah memilih APK yang paling sesuai.</p>
      <h3>Kapan Sebaiknya Memakai Versi Lama?</h3>
      <p>&check; Perangkat tidak kompatibel dengan rilis terbaru.</p>
      <p>&check; Anda menyukai fitur atau tampilan dari versi sebelumnya.</p>
      <p>&check; Anda mengalami masalah setelah update.</p>
      <p>&check; Anda membutuhkan versi tertentu untuk pengujian atau kompatibilitas.</p>
      <h3>Versi Lama Populer</h3>
      <table class="data-table old-version-table">
        <thead>
          <tr>
            <th scope="col">Versi</th>
            <th scope="col">Diperbarui</th>
            <th scope="col">Android</th>
            <th scope="col">Unduh</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in oldVersionRows" :key="row.version">
            <th scope="row">{{ row.version }}</th>
            <td>{{ row.updated }}</td>
            <td>{{ row.android }}</td>
            <td>
              <router-link to="/old-versions/">Unduh</router-link>
            </td>
          </tr>
          <tr>
            <th colspan="4" scope="row">
              Lihat Semua Versi
              <router-link to="/old-versions/">https://gb-wave.com/old-versions/</router-link>
            </th>
          </tr>
        </tbody>
      </table>
      <p><strong>Rekomendasi:</strong> Untuk stabilitas, keamanan, dan kompatibilitas lebih baik, unduh <strong>versi WA GB terbaru</strong> jika perangkat Anda mendukungnya.</p>
    </section>

    <section class="section-content">
      <h2>WA GB vs WhatsApp Resmi</h2>
      <p>Bingung memilih versi yang tepat? WhatsApp resmi berfokus pada kesederhanaan dan update otomatis, sementara WA GB menawarkan kustomisasi, opsi privasi, dan alat produktivitas tambahan untuk pengguna yang ingin kontrol lebih luas.</p>
      <blockquote class="home-note">
        <strong>Catatan:</strong> WA GB adalah versi modifikasi WhatsApp dan tidak dikembangkan atau didukung oleh WhatsApp.
      </blockquote>
      <h3>Perbandingan Fitur</h3>
      <table class="data-table data-table--compare">
        <thead>
          <tr>
            <th scope="col">Fitur</th>
            <th scope="col">WA GB</th>
            <th scope="col">WhatsApp Resmi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in compareRows" :key="row.feature">
            <th scope="row">{{ row.feature }}</th>
            <td>
              <span v-if="row.gbMark" class="cmp-mark" :class="`cmp-mark--${row.gbMark}`" aria-hidden="true" />
              <span v-if="row.gbText">{{ row.gbText }}</span>
            </td>
            <td>
              <span v-if="row.offMark" class="cmp-mark" :class="`cmp-mark--${row.offMark}`" aria-hidden="true" />
              <span v-if="row.offText">{{ row.offText }}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <h3>Mana yang Sebaiknya Dipilih?</h3>
      <p><strong>Pilih WA GB jika Anda...</strong></p>
      <ul>
        <li>Menginginkan kontrol privasi lebih lengkap.</li>
        <li>Suka menyesuaikan tampilan aplikasi.</li>
        <li>Membutuhkan balasan otomatis atau penjadwal pesan.</li>
        <li>Sering membagikan foto, video, dan dokumen berukuran besar.</li>
      </ul>
      <p><strong>Pilih WhatsApp resmi jika Anda...</strong></p>
      <ul>
        <li>Lebih suka aplikasi resmi dengan update otomatis.</li>
        <li>Ingin dukungan langsung dari WhatsApp.</li>
        <li>Tidak membutuhkan fitur kustomisasi tambahan.</li>
        <li>Lebih nyaman memasang aplikasi lewat Google Play.</li>
      </ul>
    </section>

    <section class="section-content">
      <h2>Masalah Umum dan Solusinya</h2>
      <p>Kebanyakan masalah instalasi atau update bisa diselesaikan dalam beberapa menit. Berikut beberapa masalah yang sering dialami pengguna WA GB beserta solusi yang disarankan.</p>
      <h3>WA GB Tidak Bisa Dipasang</h3>
      <p>Jika WA GB tidak bisa dipasang, penyebabnya bisa berasal dari pengaturan keamanan Android, versi perangkat yang tidak didukung, ruang penyimpanan kurang, atau file APK yang tidak lengkap.</p>
      <p>Untuk mengatasi <strong>masalah instalasi WA GB</strong>, aktifkan Sumber Tidak Dikenal, periksa kompatibilitas Android, dan unduh ulang APK jika paket rusak.</p>
      <p>
        Untuk langkah detail, baca panduan <router-link to="/gb-whatsapp-not-installing/"><strong>WA GB Tidak Bisa Dipasang</strong></router-link>.
      </p>
      <h3>Verifikasi WA GB Gagal</h3>
      <p>Error verifikasi biasanya terjadi karena nomor telepon salah, koneksi internet tidak stabil, OTP terlambat, atau pembatasan verifikasi sementara.</p>
      <p>Untuk mengatasi <strong>masalah verifikasi WA GB</strong>, pastikan nomor benar, gunakan koneksi stabil, dan tunggu sebelum meminta kode verifikasi baru.</p>
      <p>
        Baca panduan lengkap: <router-link to="/gb-whatsapp-verification-failed/"><strong>Verifikasi WA GB Gagal</strong></router-link>.
      </p>
      <h3>Update WA GB Gagal</h3>
      <p>Saat memperbarui WA GB, error instalasi dapat muncul karena file APK tidak kompatibel, penyimpanan terbatas, atau konflik dengan versi sebelumnya.</p>
      <p>
        Sebelum update, buat cadangan dan pasang <router-link to="/id/">WA GB APK terbaru</router-link> di atas aplikasi yang sudah ada bila memungkinkan. Jika masalah berlanjut, ikuti panduan <router-link to="/gb-whatsapp-update-failed/"><strong>Update WA GB Gagal</strong></router-link>.
      </p>
      <h3><strong>WA GB Sering Crash</strong></h3>
      <p>Jika WA GB sering berhenti atau crash, penyebabnya bisa berupa versi usang, file aplikasi rusak, ruang penyimpanan kurang, atau konflik dengan instalasi lama.</p>
      <p>Untuk memperbaiki <strong>masalah crash WA GB</strong>, mulai ulang perangkat, update ke versi terbaru, hapus cache aplikasi, atau instal ulang APK setelah mencadangkan chat.</p>
      <p>Untuk langkah lebih detail, cek panduan tentang <strong>WA GB Sering Crash</strong>.</p>
      <h3>Tidak Bisa Memulihkan Chat WA GB</h3>
      <p>Jika chat WA GB tidak bisa dipulihkan, penyebabnya mungkin folder cadangan salah, file backup tidak kompatibel, atau nomor telepon berbeda saat proses pemulihan.</p>
      <p>Untuk mengatasi <strong>masalah pemulihan chat WA GB</strong>, pastikan file backup berada di lokasi yang benar, gunakan nomor yang sama, dan pastikan data cadangan tidak rusak.</p>
      <h3>Masih Butuh Bantuan?</h3>
      <p>
        Jika masalah Anda belum tercantum, kunjungi <strong>Pusat Bantuan</strong> untuk panduan pemecahan masalah, tutorial instalasi, dan jawaban atas pertanyaan umum tentang WhatsApp GB.
      </p>
      <p>
        <router-link to="/troubleshooting/">Lihat Semua Panduan Bantuan</router-link>
      </p>
    </section>

    <section class="section-content">
      <h2>Apakah WA GB Aman Digunakan?</h2>
      <p>WA GB adalah versi modifikasi WhatsApp yang dibuat oleh pengembang independen, bukan tim resmi WhatsApp. Banyak pengguna memilihnya karena fitur tambahan dan opsi kustomisasi, tetapi aplikasi modifikasi tetap memiliki risiko yang perlu dipahami sebelum dipasang.</p>
      <h3>Hal yang Perlu Dipertimbangkan</h3>
      <p><strong>Unduh dari Sumber Tepercaya</strong><br>Selalu unduh APK terbaru dari situs yang dapat dipercaya untuk mengurangi risiko file tidak lengkap atau sudah dimodifikasi.</p>
      <p><strong>Jaga Aplikasi Tetap Terbaru</strong><br>Memasang versi terbaru membantu meningkatkan kompatibilitas, memperbaiki masalah yang diketahui, dan memberi pengalaman lebih stabil.</p>
      <p><strong>Cadangkan Chat</strong><br>Buat cadangan lokal sebelum update atau instal ulang agar percakapan bisa dipulihkan jika dibutuhkan.</p>
      <p><strong>Pahami Risikonya</strong><br>Karena bukan produk resmi WhatsApp, ketersediaan dan kompatibilitas WhatsApp GB dapat berubah, dan penggunaan aplikasi modifikasi bisa membawa risiko pembatasan akun.</p>
      <h3>Rekomendasi Kami</h3>
      <p>Jika Anda memutuskan memakai WA GB, pastikan aplikasi selalu diperbarui, cadangkan data secara rutin, dan hanya unduh APK dari sumber tepercaya. Langkah dasar ini dapat membantu menghindari banyak masalah instalasi dan update.</p>
    </section>

    <section class="section-content">
      <h2>Pertanyaan yang Sering Diajukan</h2>
      <FAQ :faqs="homeFaqs" variant="home" />
    </section>

    <section class="section-content">
      <h2>Panduan dan Tips Terbaru</h2>
      <p>Jelajahi panduan terbaru untuk mempelajari cara memasang, memperbarui, mencadangkan, dan memaksimalkan WA GB. Tutorial ini diperbarui secara berkala untuk pengguna baru maupun pengguna lama.</p>
      <div class="latest-guides">
        <router-link v-for="post in latestGuides" :key="post.path" :to="post.path" class="latest-guides__card">
          <img :src="post.poster" :alt="post.title" class="latest-guides__img">
          <div>
            <h3>{{ post.title }}</h3>
            <p>{{ post.desc }}</p>
            <time>{{ post.date }}</time>
          </div>
        </router-link>
      </div>
    </section>

    <section class="section-content home-cta">
      <h2>Unduh WA GB APK</h2>
      <p>Dapatkan versi terbaru dengan kontrol privasi lanjutan, tema khusus, balasan otomatis, penjadwal pesan, berbagi media HD, dan banyak fitur lain.</p>
      <a :href="downloadHref" class="home-cta__btn">
        <strong class="home-cta__btn-title">Unduh WA GB APK</strong>
        <span class="home-cta__btn-meta">Unduhan Gratis - Versi Terbaru - Android 5.0+</span>
      </a>
    </section>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/gb-wave-home.scss';
import '@/css/seo-guide-page.scss';
import HeadNav from '@/components/HeadNav.vue';
import HomeHero from '@/components/HomeHero.vue';
import FAQ from '@/components/FAQ.vue';
import apkDownload from '@/mixins/apkDownload';
import {
  APK_ANDROID,
  APK_DOWNLOAD_URL,
  APK_SIZE,
  APK_UPDATED,
  APK_VERSION,
} from '@/utlis/siteConfig';
import { guidePosts } from '@/documents/guides.js';

export default {
  name: 'HomeId',
  components: { HeadNav, HomeHero, FAQ },
  mixins: [apkDownload],
  data() {
    return {
      heroContent: {
        titleLines: [{ text: 'WA GB APK' }],
        desc:
          'Unduh WA GB APK terbaru untuk Android dengan fitur privasi, tema khusus, balasan otomatis, penjadwal pesan, dan berbagi media lebih besar hanya di GB Wave.',
        primaryCta: 'Unduh WA GB APK',
        secondaryCta: 'Lihat Versi Lama',
        specTitle: 'Versi Terbaru',
        badge: 'Direkomendasikan',
        specCta: 'Unduh Sekarang',
        featureCards: [
          { iconSvg: null, title: 'Anti-Ban', desc: 'Rilis stabil terbaru' },
          { iconSvg: null, title: 'Tema', desc: 'Kustomisasi penuh' },
          { iconSvg: null, title: 'Balasan Otomatis', desc: 'Alat pesan pintar' },
          { iconSvg: null, title: 'Media HD', desc: 'Berbagi file lebih besar' },
        ],
        specLabels: {
          Version: 'Versi',
          Android: 'Android',
          Size: 'Ukuran',
          Updated: 'Diperbarui',
          Verified: 'Terverifikasi',
          Platform: 'Platform',
        },
        specValues: {
          Verified: 'Ya',
        },
        trustLines: ['Unduhan aman', 'Instalasi cepat', 'Panduan update tersedia'],
      },
      apkInfoRows: [
        { label: 'Versi Terbaru', value: `v${APK_VERSION}` },
        { label: 'Diperbarui', value: APK_UPDATED },
        { label: 'Ukuran APK', value: APK_SIZE },
        { label: 'Android', value: APK_ANDROID },
        { label: 'Kategori', value: 'Komunikasi' },
        { label: 'Pengembang', value: 'GBMods' },
        { label: 'Lisensi', value: 'Gratis' },
        { label: 'Format File', value: 'APK' },
        { label: 'Unduhan', value: '8M+' },
        { label: 'Terakhir Diverifikasi', value: APK_UPDATED },
      ],
      homeFaqs: [
        {
          question: 'Apakah WA GB gratis untuk diunduh?',
          answer:
            'Ya. WA GB tersedia sebagai APK gratis untuk perangkat Android. Anda bisa mengunduh versi terbaru dari <strong>GB Wave</strong> bersama panduan instalasi, instruksi update, dan rilis sebelumnya.',
        },
        {
          question: 'Bisakah WA GB dipasang tanpa menghapus WhatsApp?',
          answer:
            'Dalam banyak kasus bisa, selama setiap aplikasi memakai nama paket yang berbeda. Kompatibilitas dapat berbeda tergantung versi yang Anda pasang.',
        },
        {
          question: 'Apakah chat akan hilang saat memperbarui WA GB?',
          answer:
            'Biasanya tidak. Jika versi baru dipasang di atas aplikasi yang sudah ada, chat umumnya tetap tersimpan. Namun, membuat cadangan lokal sebelum update tetap disarankan.',
        },
        {
          question: 'Mengapa APK tidak bisa dipasang?',
          answer:
            'Penyebab umum adalah izin <strong>Instal Aplikasi Tidak Dikenal</strong> belum aktif, unduhan APK tidak lengkap, atau versi Android tidak didukung. Pastikan perangkat memenuhi syarat minimum sebelum memasang.',
        },
        {
          question: 'Apakah WA GB bekerja di semua perangkat Android?',
          answer:
            'WA GB mendukung sebagian besar perangkat Android dengan <strong>Android 5.0 atau lebih baru</strong>. Beberapa fitur atau versi dapat bekerja berbeda tergantung model perangkat dan versi Android.',
        },
        {
          question: 'Bagaimana cara update ke versi terbaru?',
          answer:
            'Unduh APK terbaru dari <strong>GB Wave</strong>, lalu pasang di atas versi saat ini jika memungkinkan. Mencadangkan chat sebelum update selalu disarankan.',
        },
        {
          question: 'Bisakah chat dipulihkan setelah instal ulang WA GB?',
          answer:
            'Ya. Jika Anda memiliki cadangan lokal yang valid dan memverifikasi nomor telepon yang sama saat setup, chat dan media biasanya dapat dipulihkan.',
        },
        {
          question: 'Bisakah memakai dua akun WhatsApp di satu ponsel?',
          answer:
            'Ya. Banyak pengguna memasang WA GB bersama WhatsApp resmi untuk memakai dua nomor berbeda di perangkat Android yang sama. Kompatibilitas bergantung pada perangkat dan versi yang dipasang.',
        },
        {
          question: 'Apa yang harus dilakukan jika verifikasi gagal?',
          answer:
            'Periksa kembali nomor telepon, pastikan koneksi internet stabil, lalu minta kode verifikasi baru. Jika masih gagal, tunggu beberapa menit sebelum mencoba lagi.',
        },
      ],
      privacyRows: [
        { label: 'Ghost Mode', value: 'Tetap aktif sambil menyembunyikan kehadiran online.' },
        { label: 'Sembunyikan Status Online', value: 'Buka dan balas pesan tanpa terlihat online.' },
        { label: 'Freeze Last Seen', value: 'Pertahankan waktu terakhir dilihat agar tidak berubah.' },
        { label: 'Sembunyikan Centang Biru', value: 'Baca pesan tanpa mengirim tanda sudah dibaca.' },
      ],
      customizeRows: [
        { label: 'Tema Khusus', value: 'Pilih dari ratusan tema unik.' },
        { label: 'Font dan Warna', value: 'Ubah gaya teks dan warna antarmuka.' },
        { label: 'Wallpaper Chat', value: 'Atur latar berbeda untuk percakapan Anda.' },
        { label: 'Ikon Aplikasi', value: 'Ganti ikon default dengan gaya yang Anda suka.' },
      ],
      mediaRows: [
        { label: 'Foto HD', value: 'Bagikan gambar lebih jelas dengan kompresi lebih rendah.' },
        { label: 'Video Besar', value: 'Kirim video lebih panjang dan berukuran lebih besar.' },
        { label: 'Banyak Gambar', value: 'Kirim lebih banyak foto dalam satu pesan.' },
        { label: 'Dokumen', value: 'Bagikan PDF, ZIP, APK, dan jenis file lain.' },
      ],
      oldVersionRows: [
        { version: 'v18.70', updated: 'Oct 2026', android: '5.0+' },
        { version: 'v18.60', updated: 'Apr 2026', android: '5.0+' },
        { version: 'v18.50', updated: 'Feb 2026', android: '5.0+' },
      ],
      compareRows: [
        { feature: 'Kontrol Privasi Lanjutan', gbMark: 'yes', offText: 'Dasar' },
        { feature: 'Tema Khusus', gbMark: 'yes', offMark: 'no' },
        { feature: 'Balasan Otomatis', gbMark: 'yes', offMark: 'no' },
        { feature: 'Penjadwal Pesan', gbMark: 'yes', offMark: 'no' },
        { feature: 'Pengunduh Status', gbMark: 'yes', offMark: 'no' },
        { feature: 'Berbagi Media HD', gbMark: 'yes', offText: 'Terbatas' },
        { feature: 'Multi Akun', gbMark: 'yes', offText: 'Terbatas*' },
        { feature: 'Update Otomatis', gbMark: 'no', gbText: 'APK manual', offMark: 'yes', offText: 'Google Play' },
        { feature: 'Dukungan Resmi', gbMark: 'no', offMark: 'yes' },
      ],
      statusToolRows: [
        { label: 'Pengunduh Status', value: 'Simpan foto dan video dari Status.' },
        { label: 'Pengelola Media', value: 'Atur file unduhan dengan lebih rapi.' },
        { label: 'Pratinjau Cepat', value: 'Lihat media sebelum disimpan atau dibagikan.' },
        { label: 'Akses Galeri', value: 'Temukan konten tersimpan langsung di galeri perangkat.' },
      ],
      topFeatures: [
        { title: 'Ghost Mode', body: 'Tetap terhubung sambil menjaga aktivitas tetap pribadi. Ghost Mode membantu menyembunyikan kehadiran online sehingga Anda lebih leluasa mengatur kapan terlihat aktif.' },
        { title: 'Privasi Lanjutan', body: 'Kelola last seen, centang biru, indikator mengetik, status rekaman, dan visibilitas online dengan opsi privasi yang detail.' },
        { title: 'Tema Khusus', body: 'Ubah tampilan aplikasi dengan tema, font, ikon, wallpaper, dan gaya warna untuk pengalaman chat yang personal.' },
        { title: 'Balasan Otomatis', body: 'Balas pesan masuk secara otomatis saat sibuk, mengemudi, atau sedang tidak tersedia.' },
        { title: 'Penjadwal Pesan', body: 'Jadwalkan pesan untuk dikirim pada tanggal dan waktu tertentu, cocok untuk pengingat atau ucapan penting.' },
        { title: 'Pengunduh Status', body: 'Simpan foto dan video dari status kontak langsung ke perangkat tanpa aplikasi tambahan.' },
        { title: 'Berbagi Media HD', body: 'Bagikan foto berkualitas tinggi, video lebih panjang, dokumen, dan file besar dengan batasan lebih longgar.' },
        { title: 'Dua Akun', body: 'Gunakan beberapa akun WhatsApp di perangkat Android yang sama untuk memisahkan percakapan kerja dan pribadi.' },
      ],
      installSteps: [
        {
          num: '1',
          title: 'Unduh APK',
          body: 'Ketuk tombol <strong>Unduh WA GB APK</strong> di GB Wave dan simpan versi terbaru ke perangkat Android Anda.',
        },
        {
          num: '2',
          title: 'Aktifkan Sumber Tidak Dikenal',
          body: 'Buka <strong>Pengaturan &gt; Keamanan &gt; Instal Aplikasi Tidak Dikenal</strong>, lalu izinkan browser atau file manager memasang file APK.',
        },
        {
          num: '3',
          title: 'Pasang WA GB',
          body: 'Buka APK yang sudah diunduh dan ikuti instruksi di layar sampai instalasi selesai.',
        },
        {
          num: '4',
          title: 'Verifikasi Nomor',
          body: 'Jalankan WA GB, masukkan nomor telepon, verifikasi dengan kode SMS, dan pulihkan cadangan chat jika tersedia.',
        },
      ],
    };
  },
  computed: {
    downloadHref() {
      return this.apk || APK_DOWNLOAD_URL;
    },
    latestGuides() {
      return guidePosts
        .map((post) => {
          const map = {
            'guide-transfer': {
              title: 'Cara Memindahkan WA GB ke Ponsel Baru',
              desc: 'Pelajari cara memindahkan chat, foto, video, dan file WA GB ke ponsel baru dengan metode backup dan restore.',
            },
            'guide-update': {
              title: 'Cara Update WA GB Tanpa Kehilangan Chat',
              desc: 'Perbarui WA GB dengan aman tanpa kehilangan chat, foto, dan media. Ikuti langkah backup dan instalasi versi terbaru.',
            },
            'guide-backup': {
              title: 'Cara Backup WA GB Sebelum Update',
              desc: 'Pelajari cara mencadangkan chat, foto, video, dan file sebelum memperbarui WhatsApp GB ke versi baru.',
            },
            'guide-pin-chats': {
              title: 'Cara Memin Chat di WA GB',
              desc: 'Pelajari cara menyematkan chat penting, melepas chat yang disematkan, dan mengelola daftar chat di WA GB.',
            },
            'guide-status-videos': {
              title: 'Cara Download Video Status WA GB',
              desc: 'Pelajari cara menyimpan video status WA GB ke ponsel Android, memeriksa opsi media, dan menemukan berkas status lewat file manager.',
            },
          };
          return { ...post, ...(map[post.name] || {}) };
        })
        .sort((a, b) => (a.date < b.date ? 1 : -1))
        .slice(0, 3);
    },
  },
};
</script>

<style scoped>
.home.page {
  background:
    radial-gradient(ellipse 90% 40% at 50% -8%, rgba(40, 167, 69, 0.14), transparent 55%),
    linear-gradient(180deg, #f4fbf6 0, #f6fbf8 980px, #ffffff 1380px);
}

.home-longform {
  position: relative;
  margin-top: -18px;
  padding-top: 24px;
}

.home-longform .section-content:first-child {
  padding: 1.7rem 1.5rem 1.85rem;
  margin-bottom: 1.65rem;
}

.home-longform__h1 {
  margin: 0 0 1rem;
  padding: 0.1rem 0 0.1rem 0.85rem;
  border-left: 3px solid var(--gb-wave-green, #28a745);
  font-size: clamp(1.45rem, 3vw, 1.85rem);
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: -0.02em;
  color: #0d3d2a;
}

.home-cta.section-content {
  padding-top: 1.85rem;
  padding-bottom: 2rem;
}

.top-features-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  margin-top: 1.35rem;
}
.top-features-grid__item {
  background: #fff;
  border: 1px solid #e8ecea;
  border-radius: 14px;
  padding: 1rem;
  transition:
    transform 0.25s cubic-bezier(0.22, 1, 0.36, 1),
    box-shadow 0.25s ease,
    border-color 0.25s ease;
}

.top-features-grid__item:hover {
  transform: translateY(-3px);
  border-color: #cfe8d7;
  box-shadow: 0 14px 30px rgba(18, 76, 43, 0.1);
}
.top-features-grid__item h3 {
  margin: 0 0 0.5rem;
  font-size: 1rem;
  color: #141a22;
  font-weight: 800;
}
.top-features-grid__item p {
  margin: 0;
  font-size: 0.88rem;
  line-height: 1.45;
  color: #5b6573;
}

@media (max-width: 900px) {
  .top-features-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 520px) {
  .top-features-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}
.install-steps {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  margin: 1.35rem 0 1.65rem;
  padding: 0;
  list-style: none;
  counter-reset: none;
}

.install-steps__item {
  position: relative;
  margin: 0;
  padding: 1rem 0.9rem 1.05rem;
  list-style: none;
  border: 1px solid #dfece4;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 8px 20px rgba(24, 76, 43, 0.05);
  text-align: left;
  transition:
    transform 0.25s cubic-bezier(0.22, 1, 0.36, 1),
    box-shadow 0.25s ease,
    border-color 0.25s ease;
}

.install-steps__item:hover {
  transform: translateY(-3px);
  border-color: #b7dbc6;
  box-shadow: 0 14px 28px rgba(24, 76, 43, 0.1);
}

.install-steps__num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin-bottom: 10px;
  border-radius: 50%;
  background: linear-gradient(180deg, #1fd058 0%, #0a9c36 100%);
  color: #fff;
  font-size: 0.88rem;
  font-weight: 800;
  line-height: 1;
}

.install-steps__title {
  margin: 0 0 0.45rem;
  font-size: 0.98rem;
  font-weight: 800;
  color: #141a22;
  line-height: 1.25;
}

.install-steps__body {
  margin: 0;
  font-size: 0.86rem;
  line-height: 1.45;
  color: #5b6573;
}

.update-steps {
  list-style: none;
  margin: 1.35rem 0 1.5rem;
  padding: 0 0 0 2px;
  position: relative;
}

.update-steps::before {
  content: '';
  position: absolute;
  top: 18px;
  bottom: 18px;
  left: 17px;
  width: 2px;
  border-radius: 999px;
  background: linear-gradient(180deg, #28a745 0%, #a8e6c1 100%);
}

.update-steps__item {
  position: relative;
  display: grid;
  grid-template-columns: 36px 1fr;
  gap: 14px;
  align-items: flex-start;
  margin: 0 0 12px;
  padding: 0;
  list-style: none;
}

.home-longform .update-steps li + li {
  margin-top: 0;
}

.update-steps__item:last-child {
  margin-bottom: 0;
}

.update-steps__num {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(180deg, #1fd058 0%, #0a9c36 100%);
  color: #fff;
  font-size: 0.88rem;
  font-weight: 800;
  line-height: 1;
  box-shadow: 0 6px 14px rgba(10, 156, 54, 0.28);
}

.update-steps__body {
  margin: 0;
  padding: 12px 14px;
  border: 1px solid rgba(40, 167, 69, 0.16);
  border-radius: 12px;
  background: linear-gradient(180deg, #ffffff 0%, #f7fcf9 100%);
  box-shadow: 0 6px 16px rgba(18, 76, 43, 0.05);
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.2s cubic-bezier(0.22, 1, 0.36, 1);
}

.update-steps__item:hover .update-steps__body {
  border-color: #b7dbc6;
  box-shadow: 0 10px 22px rgba(18, 76, 43, 0.09);
  transform: translateX(2px);
}

.update-steps__title {
  margin: 0 0 0.35rem !important;
  padding: 0 !important;
  border: 0 !important;
  background: none !important;
  font-size: 0.98rem;
  font-weight: 800;
  line-height: 1.3;
  color: #141a22;
}

.update-steps__body p {
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.55;
  color: #5b6573;
}

@media (prefers-reduced-motion: reduce) {
  .update-steps__item:hover .update-steps__body {
    transform: none;
  }
}

.home-longform .old-version-table {
  width: min(100%, 680px);
  margin: 0.85rem 0 1.45rem;
}

.home-longform .old-version-table th,
.home-longform .old-version-table td {
  padding: 7px 10px;
  font-size: 0.9rem;
}

.home-longform .old-version-table thead th {
  text-align: center;
}

.home-longform .old-version-table tbody th {
  width: auto;
}

@media (max-width: 900px) {
  .install-steps {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 520px) {
  .install-steps {
    grid-template-columns: minmax(0, 1fr);
  }
}
.home-note {
  background: #f0f7f4;
  border-left: 4px solid var(--gb-wave-green);
  margin: 1.15rem 0 1.35rem;
  padding: 14px 16px;
  border-radius: 0 10px 10px 0;
  line-height: 1.7;
}
.latest-guides {
  display: grid;
  gap: 16px;
  margin-top: 1.15rem;
}
.latest-guides__card {
  display: grid;
  grid-template-columns: 180px 1fr;
  gap: 14px;
  padding: 14px;
  border: 1px solid #e8ecea;
  border-radius: 14px;
  text-decoration: none;
  color: inherit;
  background: #fff;
  overflow: hidden;
  transition:
    transform 0.25s cubic-bezier(0.22, 1, 0.36, 1),
    box-shadow 0.25s ease,
    border-color 0.25s ease,
    background 0.2s ease;
}
.latest-guides__card:hover {
  background: #f8faf9;
  transform: translateY(-2px);
  border-color: #cfe8d7;
  box-shadow: 0 14px 30px rgba(18, 76, 43, 0.1);
}
.latest-guides__img {
  width: 100%;
  height: 102px;
  object-fit: cover;
  border-radius: 8px;
  display: block;
  transition: transform 0.35s cubic-bezier(0.22, 1, 0.36, 1);
}
.latest-guides__card:hover .latest-guides__img {
  transform: scale(1.03);
}
.latest-guides__card p {
  margin: 0 0 8px;
  color: #555;
  font-size: 0.95rem;
  line-height: 1.5;
}
.latest-guides__card h3 {
  margin: 0 0 6px;
  font-size: 1.05rem;
  color: #0d3d2a;
}
.latest-guides__card time {
  font-size: 0.85rem;
  color: #888;
}
@media (max-width: 640px) {
  .latest-guides__card {
    grid-template-columns: 1fr;
  }

  .latest-guides__img {
    height: 140px;
  }
}

.home-cta {
  text-align: center;
  padding-bottom: 3rem;
}

.home-cta > h2 {
  display: inline-block;
  margin-left: auto;
  margin-right: auto;
  padding-left: 0;
  border-left: 0;
}

.home-cta__btn {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-width: min(100%, 320px);
  padding: 14px 28px 12px;
  border: 0;
  border-radius: 999px;
  background: linear-gradient(180deg, #1fd058 0%, #0a9c36 100%);
  color: #fff;
  box-shadow: 0 10px 24px rgba(9, 157, 53, 0.26);
  cursor: pointer;
  text-decoration: none;
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.home-cta__btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 28px rgba(9, 157, 53, 0.32);
}

.home-cta__btn-title {
  font-size: 1.05rem;
  font-weight: 800;
  line-height: 1.2;
  color: #fff !important;
}

.home-cta__btn-meta {
  font-size: 0.78rem;
  font-style: italic;
  font-weight: 500;
  line-height: 1.3;
  color: #fff;
  opacity: 0.92;
}

@media (max-width: 768px) {
  .home-longform {
    margin-top: -12px;
    padding-top: 16px;
  }

  .home-longform .section-content:first-child {
    padding: 1.25rem 1.05rem 1.4rem;
  }

  .home-longform__h1 {
    font-size: 1.4rem;
  }
}
</style>
